import React from 'react';
import { VentureAccountInfoComponent } from './venture-account-info.component';
import { AddressContainer } from '../../../../../common/address/containers/address.container';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { VentureUserProfileInfoComponent } from './venture-userProfile.component';
import VentureBasicInfoComponent from './add-venture.components';
import VentureLoginInfoComponent from './venture-login-info.component';

export const VentureComponent = ({ handleBasicInnerFormChange, accounts, selectedVenture, selectedAccounts, handleInnerFormChange, back, handleFormSubmit, tagNames, tags, id, handleTagFormChange }: any) => {
    console.log(id, 'nitish')
    const tabItems = [
        {
            id: 1,
            title: 'Venture-Info',
            component: (
                <VentureBasicInfoComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccounts={selectedAccounts}
                    id={id}

                />
            ),
            isVisible: id === String(0) ? true : false,
        },
        {
            id: 2,
            title: 'Login-Info',
            component: (
                <VentureLoginInfoComponent
                    handleBasicInnerFormChange={handleBasicInnerFormChange}
                    onInnerFormChange={handleInnerFormChange}
                    selectedVenture={selectedVenture}
                    id={id}
                    tagNames={tagNames}
                    tags={tags}
                    handleTagFormChange={handleTagFormChange}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 3,
            title: 'User-Info',
            component: (
                <VentureUserProfileInfoComponent
                    onInnerFormChange={handleInnerFormChange}
                    selectedVenture={selectedVenture}
                />
            ),
            isVisible: id > 0 ? true : false
        },

        {
            id: 4,
            title: 'Account-Info',
            component: (
                <VentureAccountInfoComponent
                    accounts={accounts}
                    onInnerFormChange={handleInnerFormChange}
                    selectedVenture={selectedVenture}
                />
            ),
            isVisible: id > 0 ? true : false
        },
        {
            id: 5,
            title: 'Address-Info',
            component: (
                <AddressContainer
                    onInnerFormChange={handleInnerFormChange}
                    selectedAddress={selectedVenture}
                />

            ),
            isVisible: id > 0 ? true : false
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default VentureComponent;
